import { FormInput } from "components";
import { ERROR_MESSAGE } from "constants/global";

const CheckTerm = ({ register, errors, info }) => (
  <div className="text-center">
    <div className="check-request bg-check-red-light mt-4">
      <input
        type="checkbox"
        className="check-vector2"
        id="chooseCb"
        defaultChecked={info?.chooseCb}
        {...register("chooseCb", {
          validate: (value) =>
            value === true || ERROR_MESSAGE.CHECKBOX_INQUIRY.REQUIRED,
        })}
      />
      <label htmlFor="chooseCb">個人情報の取扱いに同意する</label>
    </div>
    {errors?.chooseCb && (
      <div className="text-center">
        <div className="check-request fw-400 p-0 mt-3">
          <div className="alert alert-danger text-start">
            {errors?.chooseCb?.message}
          </div>
        </div>
      </div>
    )}
  </div>
);

const FirstName = ({ info, register, errors }) => (
  <FormInput
    register={register("last_name", {
      required: ERROR_MESSAGE.FIRST_NAME,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.FIRST_NAME,
    })}
    maxlength={40}
    defaultValue={info?.last_name}
    error={errors?.last_name?.message}
    placeholder="姓"
  />
);

const LastName = ({ info, register, errors }) => (
  <FormInput
    defaultValue={info?.first_name}
    register={register("first_name", {
      required: ERROR_MESSAGE.LAST_NAME,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.LAST_NAME,
    })}
    maxlength={40}
    error={errors?.first_name?.message}
    placeholder="名"
  />
);

const FirstNameKana = ({ info, register, errors }) => (
  <FormInput
    defaultValue={info?.last_name_kana}
    register={register("last_name_kana", {
      required: ERROR_MESSAGE.FIRST_NAME_KANA,
      pattern: {
        value: /^[ァ-ヾ]+$/u,
        message: ERROR_MESSAGE.FIRST_NAME_KANA_INVALID,
      },
    })}
    maxlength={40}
    error={errors?.last_name_kana?.message}
    placeholder="セイ"
  />
);

const LastNameKana = ({ info, register, errors }) => (
  <FormInput
    defaultValue={info?.first_name_kana}
    register={register("first_name_kana", {
      required: ERROR_MESSAGE.LAST_NAME_KANA,
      pattern: {
        value: /^[ァ-ヾ]+$/u,
        message: ERROR_MESSAGE.LAST_NAME_KANA_INVALID,
      },
    })}
    maxlength={40}
    error={errors?.first_name_kana?.message}
    placeholder="メイ"
  />
);

const Phone = ({ info, register, errors }) => (
  <FormInput
    defaultValue={info?.phone}
    register={register("phone", {
      required: ERROR_MESSAGE.PHONE.REQUIRED,
      pattern: {
        value: /^([0-9]{10}|[0-9]{11})$/,
        message: ERROR_MESSAGE.PHONE.INVALID,
      },
    })}
    placeholder={"例：08012345678"}
    type="tel"
    onlyNumber={true}
    maxlength={11}
    error={errors?.phone?.message}
  />
);

const LoginField = ({
  info,
  register,
  errors,
  watch,
  clearErrors,
  setError,
}) => (
  <FormInput
    defaultValue={info?.email}
    register={register("email", {
      required: ERROR_MESSAGE.LOGIN.REQUIRED,
      pattern: {
        value:
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/,
        message: ERROR_MESSAGE.LOGIN.INVALID,
      },
      validate: (value) => {
        if (value === watch("email_confirmation")) {
          clearErrors("email_confirmation");
        } else {
          if (watch("email_confirmation") !== null) {
            setError("email_confirmation", {
              type: "validate",
              message: ERROR_MESSAGE.LOGIN_CONFIRMATION.INVALID,
            });
          }
        }
      },
    })}
    error={errors?.email?.message}
    type="text"
  />
);

const LoginConfirmField = ({ info, register, errors, watch }) => (
  <FormInput
    defaultValue={info?.email_confirmation}
    register={register("email_confirmation", {
      required: ERROR_MESSAGE.LOGIN_CONFIRMATION.REQUIRED,
      validate: (value) =>
        value === watch("email") || ERROR_MESSAGE.LOGIN_CONFIRMATION.INVALID,
    })}
    error={errors?.email_confirmation?.message}
    type="email"
  />
);

const BodyField = ({ info, register, errors }) => (
  <>
    <textarea
      defaultValue={info?.body}
      {...register("body", {
        required: ERROR_MESSAGE.CONTENT.REQUIRED,
        validate: (value) => !!value.trim() || ERROR_MESSAGE.CONTENT.REQUIRED,
      })}
      type="text"
      rows="8"
      className={`form-control ${errors?.body ? "is-invalid" : ""}`}
    ></textarea>
    {errors?.body && (
      <div className="alert alert-danger mt-2">{errors?.body?.message}</div>
    )}
  </>
);

export {
  CheckTerm,
  FirstName,
  LastName,
  FirstNameKana,
  LastNameKana,
  Phone,
  LoginField,
  LoginConfirmField,
  BodyField,
};
